import React from "react";
import { useStyles } from "./styles";
import TuneIcon from "@material-ui/icons/Tune";

export const StatisticWidgetFilter = ({ ...props }) => {
  const classes = useStyles(props);

  return <TuneIcon className={classes.filterIcon} />;
};
StatisticWidgetFilter.muiName = "StatisticWidgetFilter";
StatisticWidgetFilter.displayName = "StatisticWidgetFilter";

export default StatisticWidgetFilter;
